import { BaseKey, IResourceComponentsProps, useExport } from '@pankod/refine-core'

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  Input,
  Divider,
  Button,
  useTable,
  Form
} from '@pankod/refine-antd'
// import { useTable } from '@pankod/refine-core'
import { ITNTaxonomy } from 'interfaces'
import { CreateTNTaxonomy } from './create'
import { EditTNTaxonomy } from './edit'
import { useState } from 'react'
import { exportToExcel } from 'exportToExcel'
const { PlusOutlined } = Icons

export const TNTaxonomyList: React.FC<IResourceComponentsProps> = () => {
  const [pagination,setHasPagination]=useState<any>(true)
  const { tableProps,searchFormProps, sorter, tableQueryResult ,setFilters} = useTable<ITNTaxonomy>({
    hasPagination:pagination,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    permanentFilter:[
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    metaData: {
      fields: [
        'id',
        'name',
        'competency_id',
        { competencies: ['name'] },
        'created_at',
        { questions: ['id'] },
        { strands: ['id'] },
        { teacher_levels: ['id'] },
      ],
    },
    onSearch: (values:any) => {
      return [
          {
              field: "name",
              operator: "contains",
              value:`%${values.title}%`,
          },
      ];
  },
  })
  const {  tableQueryResult:exportData} = useTable<ITNTaxonomy>({
    hasPagination:false,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    permanentFilter:[
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    metaData: {
      fields: [
        'id',
        'name',
        'competency_id',
        { competencies: ['name'] },
        'created_at',
        { questions: ['id'] },
        { strands: ['id'] },
        { teacher_levels: ['id'] },
      ],
    },
  })
  const { formProps, modalProps, show } = useModalForm({
    resource: 'tn_taxonomys',
    action: 'create',
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
  } = useModalForm({
    resource: 'tn_taxonomys',
    action: 'edit',
    metaData: {
      fields: ['id', 'name', 'competency_id', { competencies: ['name'] }, 'created_at'],
    },
  })

  const hideDeleteButton = (record: ITNTaxonomy): boolean => {
    // const q = record?.questions
    // const s = record?.strands
    // const tl = record?.teacher_levels
    const { questions: q, strands: s, teacher_levels: tl } = record
    if (q !== undefined && s !== undefined && tl !== undefined) {
      const shouldHide = q.length > 0 || s.length > 0 || tl.length > 0
      return shouldHide
    }
    return false
  }

  // const { triggerExport, isLoading } = useExport<ITNTaxonomy>()
  const triggerExport=()=>{
    let data:object[]=[]
    if(exportData !==undefined){
      exportData?.data?.data?.forEach((item:ITNTaxonomy)=>{
  data?.push({
    id:item?.id,
    name:item?.name,
    competency:item?.competencies?.name,
    created_at:item?.created_at


  })
})
    }
    exportToExcel(data,`Taxonomies_${Math.round(new Date().getTime() / 1000)}.xlsx`)
  }
 
  return (
    <List
      title="Taxonomy"
      pageHeaderProps={{
        extra: [
          //  <ExportButton onClick={triggerExport} loading={isLoading} />,
          <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
          <CreateButton type="primary" icon={<PlusOutlined />} onClick={() => show()} />,
          <Button onClick={triggerExport}>Export</Button>
        ],
      }}
    >
      <Form {...searchFormProps}>
        <Space>
            <Form.Item name="title">
                <Input placeholder="Search by title" allowClear  onChange={(e)=>{
                            if(e.type==='click'){
                              searchFormProps.form?.submit()
                            }}}/>
            </Form.Item>
            <Button icon={<Icons.SearchOutlined/>} onClick={searchFormProps.form?.submit} >Search</Button>
        </Space>
    </Form>
    <Divider/>
      <Table {...tableProps}>
        <Table.Column dataIndex="name" title="Name" />
        <Table.Column<ITNTaxonomy> dataIndex="competency_id" title="Competency" render={(_, record) => record?.competencies?.name} />
        <Table.Column
          dataIndex="created_at"
          title="Created At"
          render={value => <DateField value={value} format="LLL" />}
          defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
          sorter
        />
        <Table.Column<ITNTaxonomy>
          title="Actions"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton size="small" type="link" icon={null} recordItemId={record.id} onClick={() => editShow(record.id)} />
              <DeleteButton size="small" type="link" icon={null} recordItemId={record.id} hidden={hideDeleteButton(record)} />
            </Space>
          )}
        />
      </Table>
      <CreateTNTaxonomy modalProps={modalProps} formProps={formProps} />
      <EditTNTaxonomy modalProps={editModalProps} formProps={editFormProps} />
    </List>
  )
}
